<!-- eslint-disable no-mixed-operators -->
<template>
  <div style="min-height: 100%">
    <div class="text-center piv">
      <label
        class="titrePage"
        style="font-size: 40px"
      >
        {{ titreBoutique }}
      </label>
    </div>
    <v-img
      style="height: 100%; padding-top: 50px; padding-bottom: 50px"
      class="imageFond"
    >
      <div class="container-boite">
        <v-row>
          <v-col cols="12">
            <v-col cols="12">
              <v-card
                class="rounded-0 pa-7 w-100"
                elevation="0"
              >
                <v-col cols="12">
                  <FiltreCoursLigne :value="filtreObjet" />
                </v-col>

                <v-col cols="12" v-if="appStore.modele.optionRegionale.estActifMessageUrgent">
                  <v-alert
                    type="error"
                  >
                    <div v-html="appStore.modele.optionRegionale.messageUrgent"></div>
                  </v-alert>
                </v-col>

                <v-col cols="12">
                  <v-alert
                    type="warning"
                    v-if="estScolariseMaison"
                  >{{ $t("boutique.MessageScolariseMaison") }}</v-alert>

                  <v-alert
                    type="warning"
                    v-if="inscriptionEstFerme"
                  >{{ $t("boutique.MessageInscriptionTermine") }}</v-alert>

                  <v-alert
                    type="warning"
                    v-if="estOrganismeVidePeriodeExamen"
                  >{{ $t("boutique.MessageVeuillezChoisirCssId") }}</v-alert>
                </v-col>

                <v-col cols="12">
                  <CoursLigne
                    :filtreObjet="filtreObjet"
                    :listeCoursLigne="inscriptionStore.listeCoursLigne"
                  />
                </v-col>
              </v-card>
            </v-col>
          </v-col>
        </v-row>
      </div>
    </v-img>
    <BoiteNousJoindre />
    <div class="petiteLigneRouge"></div>
  </div>
</template>

<script>
import csqcOutilsCoursEte from '@/outils/CSQCOutilsCoursEte';
import csqcOutils from '@/outils/CSQCOutils';
import EleveInscriptionAjax from '@/services/EleveInscriptionAjax';
import useAppStore from '@/store/appStore';
import useInscriptionStore from '@/store/inscriptionStore';
import usePanierStore from '@/store/panierStore';
import { NiveauScolaire, TypeCours } from '@/outils/Enum';
import CoursLigne from './CoursLigne.vue';
import FiltreCoursLigne from './FiltreCoursLigne.vue';
import BoiteNousJoindre from '../Accueil/BoiteNousJoindre.vue';

const racineLocalStorage = 'csqc_coursEte_';
const localStorageCssId = 'CSSId';
const localStoragePanier = 'Panier';

export default {
  name: 'BoutiquePrincipal',
  components: {
    BoiteNousJoindre,
    FiltreCoursLigne,
    CoursLigne,
  },
  setup() {
    const appStore = useAppStore();
    const inscriptionStore = useInscriptionStore();
    const panierStore = usePanierStore();

    return { appStore, inscriptionStore, panierStore };
  },
  data() {
    return {
      chargement: true,
      filtreObjet: {
        selectTypeCours: {
          nom: this.$t('boutique.filtres.SelectTypeCoursTousType'),
          valeur: TypeCours.TousLesTypes,
        },
        selectNiveauScolaire: {
          nom: this.$t('boutique.filtres.SelectNiveauTousNiveaux'),
          valeur: NiveauScolaire.TousLesNiveaux,
        },
        selectOffreCours: null,
        rechercheBarre: '',
      },
      titreBoutique: '',
    };
  },
  async created() {
    // Obtenir Option Css
    await this.inscriptionStore.definirOptionCSS();

    // Obtenir CssId
    const valeurCssIdLocalStorage = localStorage.getItem(racineLocalStorage + localStorageCssId);

    // Si organisme est vide retourner à la page principale
    if (csqcOutilsCoursEte.ObtenirOrganisme() == null) {
      window.location.href = `${this.appStore.modele.urlBase}/#/`;
      return;
    }

    this.chargement = true;

    // Assigner CssId aux filtres
    await this.inscriptionStore.definirListeCSSMinimise();
    this.filtreObjet.selectOffreCours = this.obtenirCssSelectionneLocalStorage;

    // Si externe
    if (valeurCssIdLocalStorage == null ||
      valeurCssIdLocalStorage === undefined ||
      valeurCssIdLocalStorage === '' ||
      valeurCssIdLocalStorage === -1 ||
      valeurCssIdLocalStorage === 'null'
    ) {
      localStorage.setItem(racineLocalStorage + localStorageCssId, -1);

      EleveInscriptionAjax.obtenirListeCoursLigne(-1, csqcOutilsCoursEte.ObtenirOrganisme(), this.estScolariseMaison, true).then(async (data) => {
        // Si le panier contient un cours ne fesant pas partie de la liste des cours disponibles
        const coursPanierAvant = csqcOutils.Cloner(this.panierStore.listeCoursPanier);
        const coursPanierApres = data.filter((item) => coursPanierAvant.map((cours) => cours.id).includes(item.id));

        await this.panierStore.definirListeCoursPanier(coursPanierApres);
        const jsonCoursPanier = JSON.stringify(coursPanierApres);
        localStorage.setItem(
          racineLocalStorage + localStoragePanier,
          jsonCoursPanier,
        );
      });
    } else {
      // Une css a été choisi
      EleveInscriptionAjax.obtenirListeCoursLigne(valeurCssIdLocalStorage, csqcOutilsCoursEte.ObtenirOrganisme(), this.estScolariseMaison, true).then(async (data) => {
        this.inscriptionStore.listeCoursLigne = data;

        // Si le panier contient un cours ne fesant pas partie de la liste des cours disponibles
        const coursPanierAvant = csqcOutils.Cloner(this.panierStore.listeCoursPanier);
        const coursPanierApres = data.filter((item) => coursPanierAvant.map((cours) => cours.id).includes(item.id));

        await this.panierStore.definirListeCoursPanier(coursPanierApres);
        const jsonCoursPanier = JSON.stringify(coursPanierApres);
        localStorage.setItem(
          racineLocalStorage + localStoragePanier,
          jsonCoursPanier,
        );
      });
    }

    this.chargement = false;

    // Obtention et modification du titre selon l'année courante
    this.titreBoutique = this.$t('boutique.TitrePage').replace('{anneeCourante}', new Date().getFullYear());

    // Vérifier qu'aucun cours des années antérieures sont présents dans le localstorage (sélectionnés dans le panier en gros)
    const anneeScolaire = this.appStore.modele.anneeEnSeptembre;
    let coursPresentementDansPanier = this.panierStore.listeCoursPanier;
    coursPresentementDansPanier = coursPresentementDansPanier.filter((x) => x.anneeScolaire === anneeScolaire);
    const jsonCoursPanierVerification = JSON.stringify(coursPresentementDansPanier);
    localStorage.setItem(racineLocalStorage + localStoragePanier, jsonCoursPanierVerification);
    await this.panierStore.definirListeCoursPanier(coursPresentementDansPanier);
  },
  methods: {
  },
  computed: {
    estExterne() {
      return csqcOutilsCoursEte.EstExterne();
    },
    obtenirCssSelectionneLocalStorage() {
      const cssIdLocalStorage = localStorage.getItem(
        racineLocalStorage + localStorageCssId,
      );

      return this.inscriptionStore.listeCssMinimise.find((x) => x.cssId === parseInt(cssIdLocalStorage));
    },
    inscriptionOuverte() {
      if ((!csqcOutilsCoursEte.EstExterne() && this.appStore.modele.optionRegionale.inscriptionOuverte) || this.appStore.modele.optionRegionale.inscriptionExamenOuverte) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.inscriptionStore.afficherPanier = true;
        return true;
      } if ((csqcOutilsCoursEte.EstExterne() && this.appStore.modele.optionRegionale.inscriptionExterneOuverte) || this.appStore.modele.optionRegionale.inscriptionExamenOuverte) {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.inscriptionStore.afficherPanier = true;
        return true;
      }

      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      this.inscriptionStore.afficherPanier = false;
      return false;
    },
    estScolariseMaison() {
      return csqcOutilsCoursEte.EstScolariseMaison();
    },
    inscriptionEstFerme() {
      if (
        !csqcOutilsCoursEte.EstExterne() &&
        this.appStore.modele.optionRegionale.inscriptionTermine && this.appStore.modele.optionRegionale.inscriptionExamenTermine
      ) {
        return true;
      } if (
        csqcOutilsCoursEte.EstExterne() &&
        this.appStore.modele.optionRegionale.inscriptionExterneTermine && this.appStore.modele.optionRegionale.inscriptionExamenTermine
      ) {
        return true;
      }
      return false;
    },

    estOrganismeVidePeriodeExamen() {
      return this.appStore.modele.optionRegionale.inscriptionExamenOuverte && this.filtreObjet.selectOffreCours == null;
    },
  },
  async mounted() {
    if (!this.inscriptionOuverte) {
      this.inscriptionStore.afficherPanier = false;
      await this.panierStore.definirListeCoursPanier([]);
    } else {
      this.inscriptionStore.afficherPanier = true;
    }
    this.inscriptionStore.afficherPanier = true;
  },
};
</script>

<style scoped>

label {
  white-space: normal;
}
</style>
